export function extractManagerCode(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'object' && value.value != null) {
    return String(value.value).trim() || null;
  }
  return String(value).trim() || null;
}

export function findManagerLabel(managersList, managerValue) {
  const code = extractManagerCode(managerValue);
  if (!code || !Array.isArray(managersList)) return '';
  const matched = managersList.find((manager) => String(manager.value) === code);
  return matched ? matched.label : '';
}
